// extracted by mini-css-extract-plugin
export var active = "_da-7";
export var container = "_da-0";
export var evenWidth = "_da-4";
export var large = "_da-5";
export var outlet = "_da-8";
export var slide = "_da-2";
export var small = "_da-6";
export var tab = "_da-3";
export var tabs = "_da-1";